module.exports = __webpack_public_path__ + "assets/img/checktj.9530d682.png";